export default '/pricing/extra-slots';
